import axios from 'axios';
import { aicaBaseUrl, GET, POST, polusBaseUrl } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';

export function getReportId(payload) {
    return axios({
        url: API_ENDPOINTS.GET_REPORT_ID,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            source: 'AICA',
            ...payload,
        },
    });
}

export function fetchAuditorCommentsData(orgId: string, nature?: string) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_AUDITOR_COMMENTS_DATA,
        method: GET,
        params: {
            orgId,
            requestId: getTimeStamp(),
            ...(nature && { nature }),
        },
    });
}

export function fetchVendorSource(investorOrgId: string, modules: string[]) {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_VENDOR_SOURCE,
        method: GET,
        params: {
            name: 'AICA_VENDOR_SOURCE_MAP',
            investorOrgId,
            modules: modules.join(','),
            requestId: getTimeStamp(),
        },
    });
}

export function getRawMetadata(orgId: string) {
    return axios({
        baseURL: aicaBaseUrl,
        url: API_ENDPOINTS.GET_RAW_METADATA,
        method: GET,
        params: { orgId },
    });
}

const API_ENDPOINTS = {
    GET_REPORT_ID: '/auditedFinancials/generateReportId',
    FETCH_AUDITOR_COMMENTS_DATA: '/unifier/getAuditorCommentsData',
    FETCH_VENDOR_SOURCE: '/unifier/getVendorSourceMap',
    GET_RAW_METADATA: '/data/s2s/getRawMetadata',
};
